module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mk-c370fe88a49ab3c18701c98f02ebbcf4.svg";